<template>
	<v-row no-gutters align="center" justify="center" :class="$vuetify.breakpoint.smAndDown ? 'text-h3' : 'text-h2'" class="secondary font-weight-regular primary--text d-flex flex-column">
		<Logo width="90" height="90" />
		<div class="text-uppercase font-weight-thin" :class="$vuetify.breakpoint.smAndDown ? 'text-h4' : 'text-h3'"><translate>Error</translate> 404</div>
		<translate>Page Not Found</translate>
	</v-row>
</template>

<script>
import Logo from "@/assets/logos/Logo.vue";

export default {
	name: "NotFound",
	components: {
		Logo
	}
};
</script>